import React, { useLayoutEffect } from "react";
import { useTemporaryRef } from "../../custom-hooks/useTemporaryRef";
import Button, { buttonStyles } from "../button/button";
import type { ButtonActivationEvent } from "../button/button";
import "./ButtonFooterLayout.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface ButtonFooterLayoutProps {
  onPrimaryButtonClick?: (event: ButtonActivationEvent) => void;
  onSecondaryButtonClick?: (event: ButtonActivationEvent) => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonRef?: React.RefObject<HTMLButtonElement | null>;
  secondaryButtonRef?: React.RefObject<HTMLButtonElement | null>;
}

export default function ButtonFooterLayout(incomingProps: ButtonFooterLayoutProps) {
  const props = withDefaults(incomingProps, buttonFooterLayoutDefaultProps);

  const primaryButtonRef = useTemporaryRef(props.primaryButtonRef);
  const secondaryButtonRef = useTemporaryRef(props.secondaryButtonRef);

  /*
   * Focuses the cancel button as soon as the DOM paints
   */
  useLayoutEffect(() => {
    if (secondaryButtonRef && secondaryButtonRef.current) {
      secondaryButtonRef.current.focus();
    }
  }, [secondaryButtonRef]);

  return (
    <div className="button-footer-layout">
      <Button
        buttonStyle={buttonStyles.SECONDARY_BUTTON}
        reference={secondaryButtonRef}
        onClick={props.onSecondaryButtonClick}
      >
        {props.secondaryButtonText}
      </Button>
      <Button
        buttonStyle={buttonStyles.OPAQUE_BUTTON}
        onClick={props.onPrimaryButtonClick}
        reference={primaryButtonRef}
        className={"primary"}
      >
        {props.primaryButtonText}
      </Button>
    </div>
  );
}

const buttonFooterLayoutDefaultProps = {
  onPrimaryButtonClick: () => {},
  onSecondaryButtonClick: () => {},
  primaryButtonText: "",
  secondaryButtonText: ""
};
